import { memo, useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import UserLocationItem from "./UserLocationItem";
import { setFilteredUsersLocations } from "../../features/locs/locsSlice";

const UserLocations = ({ mapRef, hoverTimeout, mapContainerRef }) => {
  const { filteredUsersLocation } = useSelector((state) => state.locs);
  const dispatch = useDispatch();
  
  // visibleUsersLocation, redux'tan gelen filteredUsersLocation ile senkronize ediliyor.
  const [visibleUsersLocation, setVisibleUsersLocation] = useState(filteredUsersLocation);

  const {
    boundaryDepth,
  } = useSelector((state) => state.boundaries);


  useEffect(() => {
    if(boundaryDepth === 1){
      dispatch(setFilteredUsersLocations({type: "reset1"}))
    }
  },[boundaryDepth])
  
  // En güncel filteredUsersLocation'u saklamak için ref
  const filteredRef = useRef(filteredUsersLocation);
  useEffect(() => {
    filteredRef.current = filteredUsersLocation;
    // filteredUsersLocation değişince visibleUsersLocation'u hemen güncelleyin:
    setVisibleUsersLocation(filteredUsersLocation);
  }, [filteredUsersLocation]);

  // Throttle ile bounds değişiminde visibleUsersLocation hesaplamasını sınırlandırıyoruz.
  const handleBoundsChanged = useCallback(
    _.throttle(() => {
      if (mapRef.current) {
        const bounds = mapRef.current.getBounds();
        // filteredRef.current, en güncel filteredUsersLocation'u içerir.
        const visible = filteredRef.current?.filter((location) =>
          bounds.contains(
            new window.google.maps.LatLng({
              lat: parseFloat(location?.latitude),
              lng: parseFloat(location?.longitude),
            })
          )
        );
        setVisibleUsersLocation(visible);
      }
    }, 100), // 100ms throttle; deneyerek optimize edebilirsiniz.
    [mapRef]
  );

  useEffect(() => {
    if (mapRef?.current) {
      mapRef.current.addListener("bounds_changed", handleBoundsChanged);
      return () => {
        if (mapRef.current) {
          window.google.maps.event.clearListeners(mapRef.current, "bounds_changed");
        }
      };
    }
  }, [handleBoundsChanged, mapRef]);



  return (
    <>
      {visibleUsersLocation.map((item) => (
        <UserLocationItem
          hoverTimeout={hoverTimeout}
          key={item.id}
          userData={item}
          mapRef={mapRef}
          mapContainerRef={mapContainerRef}
        />
      ))}
    </>
  );
};

export default memo(UserLocations);
